import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as moment from 'moment';
//import lib
// import { capitalize } from "../../lib/string";

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export const PDF = (data: any, user: string) => {
    console.log(data, user, 'user45')
    try {
        let resultArr: any[] = [];
        data.map((item: any) => {
            resultArr.push([
                user,
                item.type !== 'fiat' ? item.spotBal : '',
                item.type !== 'fiat' ? item.coin : '',
                item.type === 'fiat' ? item.spotBal : '',
                item.type === 'fiat' ? item.coin : ''
            ]);
        });
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'landscape'; // portrait or landscape
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(10);

        const title = 'User Balance Report';
        const headers = [
            [
                "User Id",
                "Crypto Balance",
                "Token Name",
                "Fiat Balance",
                "Fiat Currency Name"
            ]
        ];
        let content = {
            startY: 50,
            head: headers,
            body: resultArr,
        };
        doc.text(title, marginLeft, 40);

        autoTable(doc, { html: '#my-table' });
        autoTable(doc, content);

        doc.save('User_Balance_Report.pdf');
    } catch (err) {
        console.log(err, 'err');
    }
};

export const CSV = (data: any) => {
    try {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'User_Balance_Report.csv');
        document.body.appendChild(link);
        link.click();
    } catch (err) { }
};

export const XLS = (data: any) => {
    try {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        const fileData = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(fileData, 'User_Balance_Report.xlsx');
    } catch (err) {
        console.log(err, 'err');
    }
};
